import React from 'react';
import GallectionSimpleView from './GallectionSimpleView';
import GallectionSimpleViewContainer, {
  OwnProps,
} from './GallectionSimpleView.container';

export default GallectionSimpleViewContainer(
  GallectionSimpleView
) as React.ComponentType<OwnProps>;
